export default "__VITE_ASSET__DocdgSAG__"